import $ from 'jquery';
import '../vendor/sticky-kit.js';
$(document).ready(function () {

    var popupLeftOffset = 100;
    var popupTopOffset = 100;
    var dimmedClassName = "state-dimmed";

    var b = $("#bankruptcymapCurrent");

    // RESIZE
    var resizeTimer;
    function resizeFunction() {
        // resize functions
        viewCalc();
    }

    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resizeFunction, 50);
    });

    function viewCalc() {

        b = $("#bankruptcymapCurrent");
        $(".bankruptcystatistics-source.swe").attr("x", b.width() - 72);

        $(".bankruptcystatistics-source.swe").attr("y", b.height() - 18);

        var svgSweden = document.getElementById('bankruptcy-swedenmap-holder');
        var svgSwedenCountiesmap = document.getElementById('bankruptcy-countiesmap-svg');

        if (svgSweden !== null) {

            svgSweden.setAttribute("viewBox", "0 0 " + b.width() + " " + b.height());
            svgSweden.setAttribute("height", b.height());
            svgSweden.setAttribute("width", b.width());
        }
        if (svgSwedenCountiesmap !== null) {
            svgSwedenCountiesmap.setAttribute("viewBox", "0 0 " + b.width() + " " + b.height());
            svgSwedenCountiesmap.setAttribute("height", b.height());
            svgSwedenCountiesmap.setAttribute("width", b.width());
        }
    }

    resizeFunction();


    $(".popoverinfo").css("display", "none");

    $("svg#bankruptcy-countiesmap-svg g#Lan path.popoverdata").on("click", function (event) {

        // ************************************************ START ZOOMING CODE ************************************************************

        b = $("#bankruptcymapCurrent");

        var clickedCounty = $(this);
        var bbox = clickedCounty[0].getBBox();

        //console.log(b.width(), b.height());

        var viewboxX = b.width() * bbox.width / b.width();
        var viewboxY = b.height() * bbox.height / b.height();

        var svg = document.getElementById('bankruptcy-municipalitiesmap-holder');

        var svgParent = document.getElementById('bankruptcy-municipalitiesmap-svg');
        svgParent.setAttribute("viewBox", "0 0 " + b.width() + " " + b.height());

        svg.setAttribute("height", b.height());
        svg.setAttribute("width", b.width());

        var qx = bbox.width / b.width();
        var qy = bbox.height / b.height();

        $(".bankruptcystatistics-source.mun").attr("x", b.width() - 66);
        $(".bankruptcystatistics-source.mun").attr("y", b.height() - 12);


        // Here the viewbox number are changed so svg is zoomed
        svg.setAttribute("viewBox", (bbox.x - 5) + " " + (bbox.y - 480 * qy) + " " + (bbox.width + 10) + " " + (bbox.height + 500 * qy));

        //$(".descriptioncircles").attr("x", bbox.x + 5);

        //$(".descriptioncircles").attr("y", bbox.y - 480 * qy);
        //$(".description-circle, .description-rect").attr("transform", "scale(" + bbox.width / b.width() + ")");

        // Code for scaling and replacing the 3 colored dots
        //$("svg#bankruptcy-municipalitiesmap-svg g.description-circle").each(function () {

        //    var g = $(this);
        //    g.attr("transform", "scale(" + qx +")");

        //    var c1 = $(this).children("circle");
        //    var t1 = $(this).children("text");

        //    c1.attr("cx", parseInt(c1.attr("cx")) + (bbox.x + 5) / qx);
        //    c1.attr("cy", parseInt(c1.attr("cy")) + (bbox.y - 480 * qy) / qx);

        //    t1.attr("x", parseInt(t1.attr("x")) + bbox.x / qx + 5);
        //    t1.attr("y", parseInt(t1.attr("y")) + (bbox.y - 480 * qy) / qx);

        //    //c1.attr("cx", parseInt(c1.attr("cx")) + bbox.x/q + 5);
        //    //c1.attr("cy", parseInt(c1.attr("cy")) + (bbox.y - 480 * ff)/q);

        //    //t1.attr("x", parseInt(t1.attr("x")) + bbox.x/q + 5);
        //    //t1.attr("y", parseInt(t1.attr("y")) + (bbox.y - 480 * ff)/q);

        //});

        //c1.attr("cx", parseInt(c1.attr("cx")) + 110);
        ////c1.attr("cy", c1.attr("cy"));
        //t1.attr("x", parseInt(t1.attr("x")) + 10);

        //svg.setAttribute("preserveAspectRatio", "none slice ");



        // ************************************************ END ZOOMING CODE **************************************************************


        $("#municipalities-map-div").toggle();
        $("#counties-map-div").toggle();

        $.ajax({
            type: "POST",
            url: "/BankruptcyStatisticsPage/GetCountyNumberCode",
            cache: false,
            data: { lettercode: $(this).attr("id") },
            success: function (data) {
                if (data.toString().length === 1) {
                    data = '0' + data;
                }

                $("svg#bankruptcy-municipalitiesmap-svg g#kommuner").children("path.popoverdata").each(function () {

                    var m = $(this);
                    if (m.attr("id").substring(0, 2) !== data) {
                        m.removeClass("state-positive state-neutral state-negative");
                        m.addClass(dimmedClassName);
                    }
                });

            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request!");
                console.log(e.responseText);
            }
        });

        var countyLetterId = $(this).attr("id");
        var countyName = $("div#popoverinfo-" + countyLetterId).children(".popoverinfo__heading").text();
        var selectedYear = $('#bankruptcystatisticspage-month-dropdown').find(":selected").parent().attr('label');

        $("#bankruptcymap-municipalities .county-name").text(countyName + ' hittills ' + selectedYear);
        $(".bankruptcymap__nav").hide();

        $("#popoverinfo-municipality")
            .css("left", (event.clientX - popupLeftOffset) + "px")
            .css("top", (event.clientY - popupTopOffset) + "px");

    });

    $("svg#bankruptcy-municipalitiesmap-svg g#kommuner path.popoverdata").on("click", function (event) {

        $("svg#bankruptcy-municipalitiesmap-svg g#kommuner").children("path.popoverdata").each(function () {

            var m = $(this);
            if (m.hasClass(dimmedClassName)) {
                var state = m.attr("data-period-change");
                m.removeClass(dimmedClassName);
                m.addClass("state-" + state);
            }
        });

        $("#municipalities-map-div").toggle();
        $("#counties-map-div").toggle();
        $(".bankruptcymap__nav").show();

        $.ajax({
            type: "POST",
            url: '/BankruptcyStatisticsPage/GetCountyLetterCode',
            cache: false,
            data: { numbercode: $(this).attr("id").substring(0, 2) },
            success: function (data) {
                if (data !== "") {
                    $("#popoverinfo-" + data)
                        .css("left", (event.clientX - popupLeftOffset) + "px")
                        .css("top", (event.clientY - popupTopOffset) + "px");
                }

            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request!");
                console.log(e.responseText);
            }
        });


        //Change position of colored dots to original placement
        $(".description-circle, .description-rect").attr("transform", "scale(1)");

        var g1 = $("#circle-1");
        var c1 = g1.children("circle");
        var t1 = g1.children("text");
        c1.attr("cx", 16);
        c1.attr("cy", 30);
        t1.attr("x", 26);
        t1.attr("y", 35);

        var g2 = $("#circle-2");
        var c2 = g2.children("circle");
        var t2 = g2.children("text");
        c2.attr("cx", 16);
        c2.attr("cy", 60);
        t2.attr("x", 26);
        t2.attr("y", 65);

        var g3 = $("#circle-3");
        var c3 = g3.children("circle");
        var t3 = g3.children("text");
        c3.attr("cx", 16);
        c3.attr("cy", 90);
        t3.attr("x", 26);
        t3.attr("y", 95);

    });

    $("#tab-current-month").on("click", function (e) {

        e.preventDefault();

        if ($(this).parent().hasClass("active") === false) {
            $(this).parent().addClass("active");
            $(this).removeClass("active");
            $("#tab-whole-year").parent().removeClass("active");
        }

        $("g#Lan path.popoverdata").each(function () {
            var p = $(this);
            p.removeClass("state-positive state-neutral state-negative");
            p.addClass("state-" + p.attr("data-county-month-change"));

            var el2 = $("div#popoverinfo-" + p.attr("id") + " h3 i");
            el2.removeClass("fa-caret-up fa-caret-down");
            el2.addClass("fa-caret-" + p.attr("data-county-month-direction"));

            var el = $("div#popoverinfo-" + p.attr("id") + " h3");
            el.removeClass("positive neutral negative");
            el.addClass(p.attr("data-county-month-change"));
            el.text(p.attr("data-county-month-percent"));

            el.prepend(el2);
        });
    });

    $("#tab-whole-year").on("click", function (e) {

        e.preventDefault();

        if ($(this).parent().hasClass("active") === false) {
            $(this).parent().addClass("active");
            $("#tab-current-month").parent().removeClass("active"); 
            $("#tab-current-month").removeClass("active");
        }

        $("g#Lan path.popoverdata").each(function () {
            var p = $(this);
            p.removeClass("state-positive state-neutral state-negative");
            p.addClass("state-" + p.attr("data-county-year-change"));

            var el2 = $("div#popoverinfo-" + p.attr("id") + " h3 i");
            el2.removeClass("fa-caret-up fa-caret-down");
            el2.addClass("fa-caret-" + p.attr("data-county-year-direction"));

            var el = $("div#popoverinfo-" + p.attr("id") + " h3");
            el.removeClass("positive neutral negative");
            el.addClass(p.attr("data-county-year-change"));
            el.text(p.attr("data-county-year-percent"));

            el.prepend(el2);

        });
    });


    $(document).on("change", "#bankruptcystatisticspage-month-dropdown", function () {
        var form = $(event.target).parents("form");
        form.submit();
    });


    // Downloading map to file -----------------------------

    $(document).on("click", ".download-to-png", function () {
        var canvas = document.getElementById("map-canvas");
        canvas.width = 358;
        canvas.height = 665;

        var svg = null;
        if ($(this).attr("id") === "download-counties-png") {
            svg = document.getElementById("bankruptcy-countiesmap-svg");
        }
        else if ($(this).attr("id") === "download-municipalities-png") {
            svg = document.getElementById("bankruptcy-municipalitiesmap-svg");
        } else {
            return;
        }

        var ctx = canvas.getContext("2d");
        var data = (new XMLSerializer()).serializeToString(svg);
        var DOMURL = window.URL || window.webkitURL || window;

        var img = new Image(canvas.width, canvas.height);
        var svgBlob = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
        var url = DOMURL.createObjectURL(svgBlob);

        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);

            var imgURI = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");

            triggerDownload(imgURI, svg);
        };
        img.src = url;
    });

    $(document).on("click", ".download-to-svg", function () {
        var svg = null;
        var btn = $(this);

        if (btn.attr("id") === "download-counties-svg") {
            svg = document.getElementById("bankruptcy-countiesmap-svg");
        }
        else if (btn.attr("id") === "download-municipalities-svg") {
            svg = document.getElementById("bankruptcy-municipalitiesmap-svg");
        } else {
            return;
        }

        saveSvg(svg, getImageFileName(svg) + ".svg");
    });

    function triggerDownload(imgURI, svg) {
        var evt = new MouseEvent("click", {
            view: window,
            bubbles: false,
            cancelable: true
        });

        var a = document.createElement("a");
        a.setAttribute("download", getImageFileName(svg) + ".png");
        a.setAttribute("href", imgURI);
        a.setAttribute("target", "_blank");

        a.dispatchEvent(evt);
    }

    function saveSvg(svgEl, name) {

        var svgData = svgEl.outerHTML;
        var preface = '<?xml version="1.0" standalone="no" ?>\r\n';
        var svgBlob = new Blob([preface, svgData], { type: "image/svg+xml;charset=utf-8" });
        var svgUrl = URL.createObjectURL(svgBlob);
        var downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    function getImageFileName(svg) {

        var filename = "Bankruptcy_statistics";

        if (svg.id === "bankruptcy-countiesmap-svg") {
            if ($("#tab-current-month").parent().hasClass("active")) {
                filename = "Bankruptcy_statistics_counties_current_month";
            }
            else if ($("#tab-whole-year").parent().hasClass("active")) {
                filename = "Bankruptcy_statistics_counties_whole_year";
            }
        } else if (svg.id === "bankruptcy-municipalitiesmap-svg") {
            filename = "Bankruptcy_statistics_municipalities";
        }
        return filename;
    }


    $(document).on("mouseover", ".st0", function () {
        var p = $(this);
        p.addClass("hoverpath");
        var thisId = p.attr("id");
        $("#popoverinfo-" + thisId).css("display", "inline");
    });

    $(document).on("mousemove", ".st0", function (event) {
        var thisId = $(this).attr("id");
        $("#popoverinfo-" + thisId)
            .css("left", (event.clientX - popupLeftOffset) + "px")
            .css("top", (event.clientY - popupTopOffset) + "px");
    });

    $(document).on("mouseout", ".st0", function () {
        var p = $(this);
        p.removeClass("hoverpath");
        var thisId = p.attr("id");
        $("#popoverinfo-" + thisId).css("display", "none");
    });


    var currentDataPeriodChangeClass = "";
    var currentDataPeriodDirectionClass = "";

    $(document).on("mouseover", "g.kommun path.popoverdata", function () {
        var hoveredpath = $(this);

        if (hoveredpath.hasClass(dimmedClassName)) {
            return;
        }

        $("#popoverinfo-municipality h2.popoverinfo__heading").text(hoveredpath.attr("data-municipality-name"));

        currentDataPeriodChangeClass = hoveredpath.attr("data-period-change");
        $("#popoverinfo-municipality h3.popoverinfo__status").addClass(currentDataPeriodChangeClass);
        $("#popoverinfo-municipality h3.popoverinfo__status span.popoverinfo__percenttext").text(hoveredpath.attr("data-period-percent"));

        currentDataPeriodDirectionClass = "fa-caret-" + hoveredpath.attr("data-period-direction");
        $("#popoverinfo-municipality h3.popoverinfo__status span.indicator i.fa").addClass(currentDataPeriodDirectionClass);

        hoveredpath.addClass("hoverpath");
        $("#popoverinfo-municipality").css("display", "inline");
    });

    $(document).on("mousemove", "g.kommun path.popoverdata", function (event) {
        $("#popoverinfo-municipality")
            .css("left", (event.clientX - popupLeftOffset) + "px")
            .css("top", (event.clientY - popupTopOffset) + "px");
    });

    $(document).on("mouseout", "g.kommun path.popoverdata", function () {
        $("#popoverinfo-municipality h3.popoverinfo__status").removeClass(currentDataPeriodChangeClass);
        $("#popoverinfo-municipality h3.popoverinfo__status span.popoverinfo__percenttext").text("");
        $("#popoverinfo-municipality h3.popoverinfo__status span.indicator i.fa").removeClass(currentDataPeriodDirectionClass);
        $(this).removeClass("hoverpath");
        $("#popoverinfo-municipality").css("display", "none");
    });

    $(document).on('change', '.bankruptcy-month-dropdown', function () {
        var selectedId = $("#SelectedValue").val();
        $.ajax({
            type: "POST",
            url: '/BankruptcyStatisticsCategoryPage/GetStatistics',
            cache: false,
            data: { selectedvalue: selectedId },
            success: function (data) {
                $("#statistics").html(data);

                $.ajax({
                    type: "POST",
                    url: '/BankruptcyStatisticsCategoryPage/GetMap',
                    cache: false,
                    data: { selectedvalue: selectedId },
                    success: function (data) {
                        $(".bankrupcysticky").html(data);


                        //todo: Sticky fungerar inte då .bankrupcysticky laddas från Ajax, testar här att anropa stick_in_parent igen mm
                        var windowWidth = $(window).width();
                        $(".bankrupcysticky").height($("#statistics").height());
                        $(document.body).trigger("sticky_kit:recalc");

                        if (windowWidth >= 1024) {
                            $(".bankrupcysticky").stick_in_parent({
                                offset_top: 120
                            });

                        } else {
                            $(".bankrupcysticky").trigger("sticky_kit:detach");
                        }

                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                        console.log(e.responseText);
                    }
                });
            },
            error: function (e) {
                console.log("Something went wrong with the AJAX request!");
                console.log(e.responseText);
            }
        });

    });


    // Triggers -----------------------------

    $("#tab-current-month").trigger("click");

    $('.bankruptcy-month-dropdown').trigger('change');
});